import React from 'react';
import { Accordion, Container } from 'react-bootstrap';

function SectionHeading({ eyebrow, title, subtitle }) {
  return (
    <div className="landing-section-heading text-center">
      {eyebrow ? <span className="landing-section-heading__eyebrow">{eyebrow}</span> : null}
      {title ? <h2 className="landing-section-heading__title">{title}</h2> : null}
      {subtitle ? <p className="landing-section-heading__subtitle">{subtitle}</p> : null}
    </div>
  );
}

export default function LandingFaq({ content }) {
  const faqItems = Array.isArray(content?.faq) ? content.faq : [];

  if (!faqItems.length) return null;

  return (
    <section className="landing-section faq-section">
      <Container>
        <SectionHeading
          eyebrow={content?.faq_eyebrow || 'Frequently Asked Questions'}
          title={content?.faq_title || 'Everything you may want to know before getting started'}
          subtitle={
            content?.faq_subtitle ||
            'Find clear answers to the most common questions about setup, usage, pricing, and platform experience.'
          }
        />

        <div className="faq-shell">
          <Accordion className="faq-accordion">
            {faqItems.map((item, index) => (
              <Accordion.Item eventKey={String(index)} key={`${item?.q || 'faq'}-${index}`}>
                <Accordion.Header>{item?.q || ''}</Accordion.Header>
                <Accordion.Body>{item?.a || ''}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </Container>
    </section>
  );
}